<template>
  <div class="login-body">
    <div class="login-container">
      <div class="login-content register-content">
        <div class="log-icon-box register-icon-box">
          <img src="../../assets/img/Fill38@2x.png" />
          <div class="title">
            {{ $i18n.locale === "en-US" ? "Sign up" : "注册" }}
          </div>
        </div>
        <el-form
          ref="registerForm"
          :model="formData"
          :rules="rules"
          :show-message="false"
        >
          <div class="log-input-box">
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="formData.username"
                :placeholder="
                  $i18n.locale === 'en-US'
                    ? 'Please enter username'
                    : '请输入用户名'
                "
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                type="text"
                :placeholder="
                  $i18n.locale === 'en-US'
                    ? 'Please enter phone'
                    : '请输入手机号'
                "
                v-model="formData.phone"
              ></el-input>
            </el-form-item>
            <el-form-item prop="email">
              <el-input
                type="text"
                :placeholder="
                  $i18n.locale === 'en-US' ? 'Please enter email' : '请输入邮箱'
                "
                v-model="formData.email"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                :placeholder="
                  $i18n.locale === 'en-US'
                    ? 'Please enter password'
                    : '请输入密码'
                "
                v-model="formData.password"
              ></el-input>
            </el-form-item>
            <el-form-item prop="checkPassword">
              <el-input
                type="password"
                :placeholder="
                  $i18n.locale === 'en-US'
                    ? 'Please enter password again'
                    : '请输入确认密码'
                "
                v-model="formData.checkPassword"
              ></el-input>
            </el-form-item>
          </div>
          <div class="log-rem-box">
            <el-checkbox v-model="formData.aggre">
              <el-button @click="dialogTableVisible = true" type="text">
                {{
                  $i18n.locale === "en-US"
                    ? "I agree to the Software Use Agreement"
                    : "我已同意《软件使用协议》"
                }}</el-button
              >
            </el-checkbox>
            <div class="rem-right">
              <span @click="routerLink('login')">{{
                $i18n.locale === "en-US" ? "Login" : "登录"
              }}</span>
            </div>
          </div>
          <div class="log-btn-box">
            <el-button type="warning" @click="registerClick">{{
              $i18n.locale === "en-US" ? "Sign up" : "注册"
            }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <!--------用户协议弹框---------->
    <el-dialog
      :title="
        $i18n.locale === 'en-US' ? 'Software usage agreement' : '软件使用协议'
      "
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div style="min-height:400px;">
        <div class="value" v-html="$t('m.protocol')"></div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div
          type="primary"
          @click="dialogTableVisible = false"
          class="dialog-footer-btn"
        >
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      formData: {
        username: "",
        phone: "",
        email: "",
        password: "",
        checkPassword: "",
        aggre: false,
      },
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("m.login.placeholder.phone"),
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: this.$t("m.login.phoneError"),
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: this.$t("m.login.placeholder.userName"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("m.login.placeholder.email"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("m.login.placeholder.password"),
            trigger: "blur",
          },
        ],
        checkPassword: [
          {
            required: true,
            message: this.$t("m.login.placeholder.password2"),
            trigger: "blur",
          },
        ],
      },
      agreementDialog: false,

      active: 1,
      dialogTableVisible: false,
    };
  },
  methods: {
    routerLink(type) {
      if (type == "login") {
        this.$router.push("/login").catch((err) => {
          console.info(err);
        });
      }
    },
    registerClick() {
      this.$refs["registerForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          if (this.formData.aggre == false) {
            this.$message.error(
              this.$i18n.locale === "en-US"
                ? "Please agree to the 'Software Use Agreement'"
                : "请同意《软件使用协议》"
            );
          }
          if (this.formData.password.length < 8) {
            this.$message.error(
              this.$i18n.locale === "en-US"
                ? "Please agree to the 'Software Use Agreement'"
                : "密码长度不能小于8位"
            );
            return;
          }
          if (this.formData.password != this.formData.checkPassword) {
            this.$message.error(
              this.$i18n.locale === "en-US"
                ? "Confirm that the password is different from the password'"
                : "确认密码和密码不同"
            );
          } else {
            let params = new URLSearchParams();
            params.append("name", this.formData.username);
            params.append("phone", this.formData.phone);
            params.append("email", this.formData.email);
            params.append("pwd", this.formData.password);
            params.append("photo", "no photo");
            this.$http
              .post("/manage/user/register.do", params)
              .then(
                function(resp) {
                  if (resp.data.success) {
                    this.$message.success({
                      message:
                        this.$i18n.locale === "en-US"
                          ? "Registration succeeded. Please login"
                          : "注册成功，请登录！",
                      duration: 2000,
                      onClose: () => {
                        this.$router.push("/login");
                      },
                    });
                  } else {
                    this.$message.error(resp.data.msg);
                  }
                }.bind(this)
              )
              .catch((err) => err);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.register-content {
  padding-top: 142px !important;
}

.register-icon-box {
  top: 20px !important;
}

.login-body
  .login-container
  .login-content
  .log-input-box
  .el-input:last-child {
  margin-bottom: 13px;
}

.el-form {
  width: 100%;
}

.el-form-item {
  margin-bottom: 0;
}

.login-body .login-container .login-content .log-rem-box {
  margin-bottom: 13px;
}

</style>
